import React, { useContext, useEffect } from "react";

//global state
import { StateContext, StateDispatchContext } from "../../AppStateContext";

//styling
import "./clusterRow.css";

//Material UI stuff
import Tooltip from "@material-ui/core/Tooltip";

//helper functions
import { connectCluster } from "./helpers";

const ClusterRowInfoMobileConnect = ({ clusterInfo }) => {
  //access global state to update weaviate uri
  const state = useContext(StateContext);
  const setState = useContext(StateDispatchContext);

  //it runs to connect to the cluster
  const handleClick = () => {
    connectCluster(state, setState, clusterInfo);
  };

  useEffect(() => {
    //it disconnects the current cluster if for some reason
    //it went back to provisioning state
    if (
      state.connectToWeaviateURI ===
        `https://${clusterInfo.data.meta.PublicURL}` &&
      clusterInfo.data.status.state.percentage !== 100
    ) {
      setState({ ...state, connectToWeaviateURI: "" });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clusterInfo.data.status.state.percentage, state.connectToWeaviateURI]);

  //This will display either a disabled button if the cluster is still provisioning
  //or a enabled button so the user can connect to that cluster
  return (
    <div style={{ margin: " 5px 0 0 7px" }}>
      {clusterInfo.data.status.state.percentage === 100 ? (
        <button
          style={{
            background: "transparent",
            border: "none",
            color:
              state.connectToWeaviateURI ===
              `https://${clusterInfo.data.meta.PublicURL}`
                ? "#38d611"
                : "#fa0171",
          }}
          onClick={handleClick}
          className={
            state.theme === "dark"
              ? "__connectToClusterButton __connectToClusterButtonDark"
              : "__connectToClusterButton __connectToClusterButtonLight"
          }
        >
          {state.connectToWeaviateURI ===
          `https://${clusterInfo.data.meta.PublicURL}`
            ? "CONNECTED"
            : "CONNECT"}
        </button>
      ) : (
        <Tooltip
          title="Cluster needs to be ready in order to connect."
          placement="bottom"
        >
          <button
            style={{ background: "transparent", color: "#848484" }}
            className="__connectToClusterButtonMobileDisabled"
          >
            CONNECT
          </button>
        </Tooltip>
      )}
    </div>
  );
};

export default ClusterRowInfoMobileConnect;
